import React from 'react';
import classnames from 'classnames';

export interface DrawerAppContentProps {
  tag?: string;
  className?: string;
}

const DrawerAppContent: React.FunctionComponent<DrawerAppContentProps> = ({
  tag: Tag = 'div',
  children,
  className = '',
  ...otherProps
}) => {
  return (
    // https://github.com/Microsoft/TypeScript/issues/28892
    // @ts-ignore
    <Tag
      className={classnames('mdc-drawer-app-content', className)}
      {...otherProps}
    >
      {children}
    </Tag>
  );
};

export default DrawerAppContent;
